import { photoUploadError } from '@jobos/shared';

// Decides what should happen when image files are dropped onto a photo slot.
// Pure so the validate/upload/confirm branching can be unit-tested without the
// editor. A slot holds one photo, so only the first dropped file is considered.
export type SlotDropPlan =
  | { kind: 'none' }
  | { kind: 'reject'; message: string }
  | { kind: 'upload'; file: File }
  | { kind: 'confirm'; file: File };

export function planSlotDrop(files: File[], slotFilled: boolean): SlotDropPlan {
  const file = files[0];
  if (!file) return { kind: 'none' };

  const error = photoUploadError(file.type, file.size, file.name);
  if (error) return { kind: 'reject', message: error };

  return slotFilled ? { kind: 'confirm', file } : { kind: 'upload', file };
}
